import styled from 'styled-components';
import { widthResize, widthFull, heightFooter, textMuted, border, bgLight } from '../Resources/Theme';

export default styled.footer`
  width: calc(100% - ${props => props.resize ? widthResize : widthFull});
  margin-left: ${props => props.resize ? widthResize : widthFull};
  transition: .5s;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${heightFooter};
  min-height: 40px;
  font-size: 0.75rem;
  color: ${textMuted};
  border-top: 1px solid ${border};
  background: ${bgLight};
  padding: 12px 16px;

  @media (max-width: 992px) {
    margin-left: 0;
    width: 100%;
  }
`;
